import { render, staticRenderFns } from "./releaseVersion.vue?vue&type=template&id=5a0da571&scoped=true&"
import script from "./releaseVersion.vue?vue&type=script&lang=js&"
export * from "./releaseVersion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a0da571",
  null
  
)

export default component.exports